import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoComments = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 123,
	height: 105,
	viewBox: "0 0 123 105",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M57.0555 103.018C85.0555 103.018 107.756 80.3176 107.756 52.2176C107.756 24.1176 85.0555 1.4176 57.0555 1.4176C29.0555 1.4176 6.35553 24.1176 6.35553 52.2176C6.35553 80.3176 29.0555 103.018 57.0555 103.018Z",
			fill: "#F1F3F9",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M113.556 36.3176C115.82 36.3176 117.656 34.4819 117.656 32.2176C117.656 29.9532 115.82 28.1176 113.556 28.1176C111.291 28.1176 109.456 29.9532 109.456 32.2176C109.456 34.4819 111.291 36.3176 113.556 36.3176Z",
			fill: "#EAEEF9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M119.556 20.2176C121.102 20.2176 122.356 18.964 122.356 17.4176C122.356 15.8712 121.102 14.6176 119.556 14.6176C118.009 14.6176 116.756 15.8712 116.756 17.4176C116.756 18.964 118.009 20.2176 119.556 20.2176Z",
			fill: "#EAEEF9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.85554 39.2176C4.40194 39.2176 5.65554 37.964 5.65554 36.4176C5.65554 34.8712 4.40194 33.6176 2.85554 33.6176C1.30914 33.6176 0.055542 34.8712 0.055542 36.4176C0.055542 37.964 1.30914 39.2176 2.85554 39.2176Z",
			fill: "#EAEEF9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M74.4554 22.8607C91.7181 22.8607 105.643 35.4152 105.643 50.8491C105.643 59.7178 101.04 67.6651 93.7896 72.8481V84.4812C93.7896 86.0937 91.9482 86.8999 90.7974 85.9785L80.9001 78.2615C78.8286 78.6071 76.7571 78.8374 74.5705 78.8374C57.3078 78.8374 43.3826 66.283 43.3826 50.8491C43.3826 35.4152 57.3078 22.8607 74.4554 22.8607Z",
			fill: "#D6DCE8",
			stroke: "#AAB2C5",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.958 21.4785C24.7389 21.4785 9.20253 35.4151 9.20253 52.5767C9.20253 62.482 14.3813 71.3507 22.4372 76.9945V89.8945C22.4372 91.6221 24.3937 92.6588 25.7747 91.507L36.8228 82.9838C39.1245 83.4445 41.4262 83.6748 43.8429 83.6748C63.062 83.6748 78.5984 69.7383 78.5984 52.5767C78.5984 35.4151 63.062 21.4785 43.958 21.4785Z",
			fill: "white",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.6222 53.8437C34.7196 53.8437 36.42 52.142 36.42 50.0428C36.42 47.9437 34.7196 46.2419 32.6222 46.2419C30.5247 46.2419 28.8244 47.9437 28.8244 50.0428C28.8244 52.142 30.5247 53.8437 32.6222 53.8437Z",
			fill: "#AAB2C5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.143 53.8437C56.2405 53.8437 57.9408 52.142 57.9408 50.0428C57.9408 47.9437 56.2405 46.2419 54.143 46.2419C52.0455 46.2419 50.3452 47.9437 50.3452 50.0428C50.3452 52.142 52.0455 53.8437 54.143 53.8437Z",
			fill: "#AAB2C5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.1586 65.9375C47.8133 65.9375 47.4681 65.8223 47.2379 65.4767C46.3172 64.2098 44.9362 63.5187 43.325 63.5187C41.8289 63.5187 40.3328 64.2098 39.5273 65.4767C39.182 66.0526 38.4915 66.1678 37.9161 65.7071C37.3407 65.3616 37.2256 64.6705 37.6859 64.0946C38.9518 62.2518 41.1384 61.1 43.4401 61.1C45.7418 61.1 47.8133 62.2518 49.1943 64.0946C49.5396 64.6705 49.4245 65.3616 48.9642 65.7071C48.6189 65.9375 48.3888 65.9375 48.1586 65.9375Z",
			fill: "#AAB2C5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.397 18.5555C35.2583 18.5555 35.1195 18.5555 34.9807 18.5555C34.2869 18.2777 33.8706 17.5834 34.0094 16.889L36.3684 9.25081C36.6459 8.55644 37.3397 8.13981 38.0335 8.27868C38.7273 8.55644 39.1436 9.25081 39.0049 9.94519L36.7847 17.5834C36.6459 18.1389 36.0908 18.5555 35.397 18.5555Z",
			fill: "#AAB2C5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.569 20.222C29.014 20.222 28.4589 19.8054 28.1814 19.2499L24.5736 8.27874C24.296 7.58436 24.7123 6.7511 25.4061 6.47335C26.1 6.1956 26.9325 6.61223 27.21 7.30661L30.8179 18.2778C31.0954 18.9722 30.6791 19.8054 29.9853 20.0832C29.8465 20.222 29.7078 20.222 29.569 20.222Z",
			fill: "#AAB2C5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.1573 22.8607C23.741 22.8607 23.4635 22.7219 23.1859 22.4441L18.7455 18.139C18.1905 17.5835 18.1905 16.7502 18.7455 16.1947C19.3006 15.6392 20.1332 15.6392 20.6882 16.1947L25.1286 20.4998C25.6837 21.0554 25.6837 21.8886 25.1286 22.4441C24.8511 22.7219 24.4348 22.8607 24.1573 22.8607Z",
			fill: "#AAB2C5"
		})
	]
});
export { SvgNoComments as ReactComponent };
